import { useContext } from 'react';
import { AuthContext } from './auth-context.js';
import type { AuthContextValue } from './auth-context.js';

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (ctx === null) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return ctx;
}
